export default {
  "oK": "OK",
  "noAccess": "No Access",
  "missing": "Missing",
  "daemon": "Daemon",
  "failedToEndImpersonation": "Failed to end impersonation",
  "config": "Config",
  "unknownError": "Unknown error",
  "networkError": "Network error",
  "serviceAccess": "Service & Access",
  "copyURL": "Copy URL",
  "uRLCopied": "URL copied",
  "unit": "Unit",
  "svcs": "Svcs",
  "running": "Running",
  "stopped": "Stopped",
  "ports": "Ports",
  "socket": "Socket",
  "aPISecrets": "API & Secrets",
  "loading": "Loading...",
  "aPIKey": "API Key",
  "unavailable": "Unavailable",
  "aPIKeyWillBeAvailableOnceTheServiceIs": "API key will be available once the service is online",
  "noDiscoverableSecrets": "No discoverable secrets",
  "paths": "Paths",
  "data": "Data",
  "log": "Log",
  "install": "Install",
  "noPathInformationAvailable": "No path information available",
  "operations": "Operations",
  "logs": "Logs",
  "open": "Open",
  "editConfig": "Edit Config",
  "editConfigNow": "Edit Config Now",
  "editConfigurationFile": "Edit configuration file",
  "editNginx": "Edit Nginx",
  "editNginxNow": "Edit Nginx Now",
  "editNginxReverseProxyConfig": "Edit nginx reverse proxy config",
  "browseAppSQLiteDatabaseReadOnly": "Browse app SQLite database (read-only)",
  "browseDB": "Browse DB",
  "backup": "Backup",
  "fullBackup": "Full backup",
  "configOnly": "Config Only",
  "nginxOnly": "Nginx Only",
  "restoreFromBackup": "Restore from backup",
  "restore": "Restore",
  "links": "Links",
  "website": "Website",
  "documentation": "Documentation",
  "appDocumentation": "App Documentation",
  "aPIDocumentation": "API Documentation",
  "quickBoxDocs": "QuickBox Docs",
  "all": "All",
  "disabled": "Disabled",
  "retry": "Retry",
  "mASKED": "MASKED",
  "empty": "empty",
  "databaseBrowser": "Database Browser — {{app}}",
  "closeDatabaseBrowser": "Close database browser",
  "readOnly": "Read Only",
  "loadingDatabases": "Loading databases...",
  "noDatabasesAvailable": "No databases available",
  "thisApplicationDoesNotHaveAnyBrowsableDatabases": "This application does not have any browsable databases.",
  "databasesUnavailable": "Databases unavailable",
  "fileNotAccessible": "File not accessible",
  "filterTables": "Filter tables...",
  "noTablesMatchFilter": "No tables match filter",
  "selectATableToBrowse": "Select a table to browse",
  "couldNotLoadRows": "Could not load rows",
  "noRows": "No rows",
  "thisTableIsEmpty": "This table is empty.",
  "previous": "Previous",
  "next": "Next",
  "failed": "Failed",
  "changeReleaseChannel": "Change release channel",
  "pending": "Pending",
  "migrate": "Migrate",
  "update": "Update",
  "updatePending": "Update Pending",
  "installed": "Installed",
  "unknown": "Unknown",
  "latest": "Latest",
  "aNewVersionHasBeenDetectedButTheDownload": "A new version has been detected but the download package has not been published upstream yet. The update will become available once the package is released.",
  "updateNow": "Update Now",
  "viewUpdates": "View Updates",
  "application": "Application",
  "status": "Status",
  "version": "Version",
  "port": "Port",
  "actions": "Actions",
  "collapseDetails": "Collapse details",
  "expandDetails": "Expand details",
  "connection": "Connection",
  "details": "Details",
  "on": "On",
  "off": "Off",
  "applications": "Applications",
  "moduleIsNowActive": "Module is now active.",
  "moduleHasBeenDisabled": "Module has been disabled.",
  "manageYourInstalledApplicationsAndServices": "Manage your installed applications and services.",
  "refresh": "Refresh",
  "noApplicationsInstalled": "No applications installed",
  "installApplicationsViaTheQuickBoxCLIToManageThem": "Install applications via the QuickBox CLI to manage them here.",
  "no": "No",
  "clearFilter": "Clear filter",
  "failedToLoadBackups": "Failed to load backups",
  "configurationRestored": "Configuration restored",
  "restoreFailed": "Restore failed",
  "backupDeleted": "Backup deleted",
  "deleteFailed": "Delete failed",
  "selectABackupToRestore": "Select a backup to restore",
  "close": "Close",
  "loadingBackups": "Loading backups...",
  "noBackupsAvailable": "No backups available",
  "createABackupFirstUsingTheBackupMenuThen": "Create a backup first using the Backup menu, then you can restore from it here.",
  "backupCurrentConfigBeforeRestoring": "Backup current config before restoring",
  "cancel": "Cancel",
  "confirmDelete": "Confirm delete",
  "cancelDelete": "Cancel delete",
  "deleteBackup": "Delete backup",
  "configurationFileHasNotBeenCreatedYet": "Configuration file has not been created yet.",
  "failedToLoadConfigurationFile": "Failed to load configuration file",
  "configurationSaved": "Configuration saved",
  "configurationNotInitialized": "Configuration not initialized",
  "failedToSaveConfiguration": "Failed to save configuration",
  "youHaveUnsavedChangesDiscardThem": "You have unsaved changes. Discard them?",
  "modified": "Modified:",
  "closeEditor": "Close editor",
  "editingConfigFor": "Editing config for",
  "selectTheUserWhoseConfigurationToEdit": "Select the user whose configuration to edit",
  "searchUsersByNameOrEmail": "Search users by name or email",
  "switchingUsersDiscardsUnsavedChangesAndLoadsThatUser": "Switching users discards unsaved changes and loads that user's file.",
  "selectAUserToLoadTheirConfiguration": "Select a user to load their configuration.",
  "loadingConfiguration": "Loading configuration...",
  "failedToLoadFile": "Failed to load file",
  "fileIsEmpty": "File is empty",
  "wordWrap": "Word wrap",
  "createBackupBeforeSaving": "Create backup before saving",
  "save": "Save",
  "configurationNotInitializedYet": "Configuration not initialized yet",
  "theFileWillBeCreatedByTheApplicationItself": "The file will be created by the application itself on first use — the editor cannot create it safely from a blank template.",
  "keptTruth": "Kept (truth)",
  "keptMaxId": "Kept (max id)",
  "parseMiss": "Parse miss",
  "updatedTruth": "Updated (truth)",
  "source": "source:",
  "kept": "Kept",
  "id": "id",
  "deleted": "Deleted",
  "rowIds": "Row ids",
  "rawLogLines": "Raw log lines: {{count}}",
  "reconcileRawLogLines": "Reconcile raw log lines",
  "apply": "Apply",
  "dryRun": "Dry-run",
  "reconcile": "Reconcile",
  "reconciliationAppliedReviewPerGroupDecisionsBelow": "Reconciliation applied. Review per-group decisions below.",
  "previewOnlyNoRowsMutated": "Preview only — no rows mutated.",
  "awaitingReconcilerResponse": "Awaiting reconciler response…",
  "closeReconcileModal": "Close reconcile modal",
  "runningReconciler": "Running reconciler…",
  "reconcileFailed": "Reconcile failed",
  "groups": "Groups",
  "updated": "Updated",
  "truthMisses": "Truth misses",
  "noDuplicateGroupsToReconcile": "No duplicate groups to reconcile.",
  "credentialsFileNotFoundYetInstallMayStillBe": "Credentials file not found yet — install may still be in progress",
  "permissionDenied": "Permission denied",
  "unexpectedError": "Unexpected error",
  "unableToLoadCredentials": "Unable to load credentials",
  "username": "Username",
  "password": "Password",
  "dispatcharrAdminUsername": "Dispatcharr admin username",
  "copyUsername": "Copy username",
  "dispatcharrAdminPassword": "Dispatcharr admin password",
  "copyPassword": "Copy password",
  "hidePassword": "Hide password",
  "showPassword": "Show password",
  "storedAt": "Stored at {{path}}",
  "hide": "Hide",
  "reveal": "Reveal",
  "copied": "Copied!",
  "copy": "Copy",
  "dryRunFailed": "Dry-run failed",
  "applyDatabaseReconcile": "Apply database reconcile?",
  "applyReconcile": "Apply reconcile",
  "databaseReconciled": "Database reconciled",
  "databaseReconciliation": "Database reconciliation",
  "dryRunShowsWhatTheReconcilerWouldDoWithout": "Dry-run shows what the reconciler would do without mutating the database. Apply executes the reconciler.",
  "xCServer": "XC Server",
  "iPTVBossAppliesGUILicenseActivationAndConfigChangesOnly": "IPTVBoss applies GUI license activation and config changes only after a reload.",
  "applyReload": "Apply / Reload",
  "reloadToApplyGUIChanges": "Reload to apply GUI changes",
  "xCEndpoint": "XC endpoint",
  "notReverseProxiedYet": "Not reverse-proxied yet",
  "enabled": "Enabled",
  "notConfigured": "Not configured",
  "manage": "Manage",
  "desktop": "Desktop",
  "whatSynced": "What synced",
  "syncActivity": "Sync activity",
  "fullLog": "Full log",
  "live": "Live",
  "history": "History",
  "syncRunsOnTheScheduleSetInIPTVBossSettings": "Sync runs on the schedule set in IPTVBoss (Settings → Sync Schedule) or the Server Console. This view is read-only.",
  "iPTVBossPanel": "IPTVBoss panel",
  "recentSync": "Recent Sync",
  "desktopRemoteRequired": "Desktop remote required",
  "iPTVBossIsConfiguredThroughItsDesktopGUIInstallNoVNC": "IPTVBoss is configured through its desktop GUI. Install noVNC or x2go to reach the desktop environment — without one you cannot activate the license or edit the configuration.",
  "openDesktopNoVNC": "Open Desktop (noVNC)",
  "launchX2GoForApplicationUI": "Launch X2Go for application UI",
  "selectAnApplicationToViewSyncActivity": "Select an application to view sync activity.",
  "range": "Range:",
  "sync": "sync",
  "disableLineWrap": "Disable line wrap",
  "wrapLines": "Wrap lines",
  "wrapLongLines": "Wrap long lines",
  "iPTVBossRecentSyncActivity": "IPTVBoss recent sync activity",
  "noRecentSyncActivityInTheCurrentLog": "No recent sync activity in the current log.",
  "loading2": "Loading…",
  "justNow2": "just now",
  "noCompletedSyncRecorded": "No completed sync recorded",
  "dueNow": "due now",
  "noScheduledRunFound": "No scheduled run found",
  "lastSync": "Last sync",
  "nextSync": "Next sync",
  "pausedWhileTheXCServerIsStopped": "Paused while the XC Server is stopped",
  "unableToRevealTheVNCPassword": "Unable to reveal the VNC password.",
  "noVNCPasswordUpdated": "noVNC password updated",
  "unableToSetTheVNCPassword": "Unable to set the VNC password.",
  "customPasswordSet": "Custom password set",
  "usingDefault": "Using default",
  "current": "Current",
  "currentNoVNCPassword": "Current noVNC password",
  "hideCurrentPassword": "Hide current password",
  "revealCurrentPassword": "Reveal current password",
  "change": "Change",
  "set": "Set",
  "newPassword": "New password",
  "newNoVNCPassword": "New noVNC password",
  "hideEntry": "Hide entry",
  "showWhatYouReTyping": "Show what you're typing",
  "hideEnteredPassword": "Hide entered password",
  "showEnteredPassword": "Show entered password",
  "noVNCUsesOnlyTheFirst8CharactersOfThe": "noVNC uses only the first 8 characters of the password.",
  "savingRestartsNoVNCAndDisconnectsAnyActiveDesktopSession": "Saving restarts noVNC and disconnects any active desktop session.",
  "core": "Core",
  "remove": "Remove",
  "pluginInstalled": "Plugin installed",
  "pluginRemoved": "Plugin removed",
  "ruTorrentPlugins": "ruTorrent Plugins",
  "changesApplyServerWideInstallingOrRemovingAffectsRuTorrent": "Changes apply server-wide — installing or removing affects ruTorrent for every user, not just you.",
  "searchPlugins": "Search plugins...",
  "searchRuTorrentPlugins": "Search ruTorrent plugins",
  "loadingPlugins": "Loading plugins...",
  "plugins": "Plugins",
  "downloading": "Downloading",
  "seeding": "Seeding",
  "checking": "Checking…",
  "progress": "Progress",
  "totalSize": "Total size",
  "downloadSpeed": "Download speed",
  "uploadSpeed": "Upload speed",
  "shareRatio": "Share ratio",
  "connectedPeers": "Connected peers",
  "fileCount": "File count",
  "failedToLoadFiles": "Failed to load files",
  "whatYouReSeeing": "What you're seeing",
  "aLiveViewOfTheDownloadsEachClientIs": "A live view of the downloads each client is tracking — progress, speeds, and ratios. To browse the finished files on disk, use the Open download folder link.",
  "howThisDataIsGathered": "How this data is gathered",
  "forRTorrentLiveStatsComeStraightFromTheClient": "For rTorrent, live stats come straight from the client. Other clients are read from their tracking files. Data refreshes automatically every 10 seconds.",
  "downloadActivity": "Download Activity",
  "noDownloadClientsInstalled": "No download clients installed",
  "browseAndDownloadTheActualFilesInThisClient": "Browse and download the actual files in this client's download folder (opens in a new tab)",
  "openDownloadFolder": "Open download folder",
  "noActiveDownloads": "No active downloads",
  "thisIsAQuickViewUtilityForMonitoringDownloads": "This is a quick-view utility for monitoring downloads. For full control (adding, removing, configuring torrents), use your client's native web interface like ruTorrent, Flood, or Deluge WebUI.",
  "quickViewOnly": "Quick view only",
  "selectAnApplicationToViewLogHistory": "Select an application to view log history.",
  "applicationLogHistory": "Application log history",
  "pID": "PID:",
  "source2": "Source:",
  "cursor": "Cursor:",
  "loadMore": "Load more",
  "noLogsAvailable": "No logs available",
  "theServiceMayBeStoppedAndNoReadableLog": "The service may be stopped and no readable log file exists.",
  "noLogFile": "No log file",
  "thisApplicationHasNoReadableLogFileToFollow": "This application has no readable log file to follow.",
  "logNotReadable": "Log not readable",
  "thisLogExistsButTheDashboardServiceCanT": "This log exists but the dashboard service can't read it yet.",
  "canTReachTheLogStream": "Can't reach the log stream",
  "unableToConnectToTheLogStream": "Unable to connect to the log stream.",
  "serviceStopped": "Service stopped",
  "thisApplicationIsStoppedStartTheServiceToView": "This application is stopped. Start the service to view live logs.",
  "logStreamEnded": "Log stream ended",
  "theLogStreamEnded": "The log stream ended.",
  "selectAnApplicationToViewLiveLogs": "Select an application to view live logs.",
  "reconnect": "Reconnect",
  "resume": "Resume",
  "pause": "Pause",
  "clear": "Clear",
  "applicationLiveLog": "Application live log",
  "waitingForLogEntries": "Waiting for log entries…",
  "connectingToLogStream": "Connecting to log stream…",
  "jumpToLatest": "Jump to latest",
  "searchForARecipient": "Search for a recipient",
  "searchByUsernameOrEmail": "Search by username or email",
  "clearSelectedRecipient": "Clear selected recipient",
  "noMatchingUsers": "No matching users.",
  "couldnTUpdateRoute": "Couldn't update route",
  "pleaseTryAgain": "Please try again.",
  "routeEnabled": "Route enabled",
  "routeDisabled": "Route disabled",
  "routed": "Routed",
  "direct": "Direct",
  "externalEgress": "External egress",
  "external": "External",
  "exitsFrom": "Exits from",
  "via": "Via",
  "noEgressDetailYet": "No egress detail yet.",
  "localReverseProxyTarget": "Local reverse-proxy target",
  "local": "Local",
  "reverseProxyTarget": "Reverse-proxy target:",
  "failedToLoadProfile": "Failed to load profile",
  "profileCopiedToClipboard": "Profile copied to clipboard",
  "failedToCopyProfile": "Failed to copy profile",
  "configViewer": "Config Viewer",
  "closeProfileViewer": "Close profile viewer",
  "privateKeysAndTlsCryptMaterialAreRedactedThe": "Private keys and tls-crypt material are redacted. The CA and client certificate are public.",
  "loadingProfile": "Loading profile...",
  "never": "Never",
  "connecting": "Connecting…",
  "disconnected": "Disconnected",
  "connectingToStatsStream": "Connecting to stats stream...",
  "unableToConnectToStatsStream": "Unable to connect to stats stream",
  "liveMetrics": "Live Metrics",
  "transfer": "Transfer",
  "totalReceived": "Total received",
  "totalSent": "Total sent",
  "peer": "Peer:",
  "exitIP": "Exit IP:",
  "throughput": "Throughput",
  "yourPersonalVPNConfigIsReadyToDownloadIn": "Your personal VPN config is ready to download in the panel below",
  "configReady": "Config ready",
  "anAdminHasnTGeneratedAPersonalVPNConfig": "An admin hasn't generated a personal VPN config for your account yet",
  "noPersonalConfig": "No personal config",
  "atLeastOneTunnelHasAFreshHandshake": "At least one tunnel has a fresh handshake",
  "routedAppsAreConfiguredButNoTunnelHandshakeIs": "Routed apps are configured but no tunnel handshake is fresh",
  "noAppsRoutedThroughTheVPN": "No apps routed through the VPN",
  "myVPNConfig": "My VPN Config",
  "checkingForYourVPNConfig": "Checking for your VPN config…",
  "generated": "Generated",
  "opensTheSecureDownloadPromptsForYourQuickBoxPassword": "Opens the secure download (prompts for your QuickBox password)",
  "download": "Download",
  "view": "View",
  "connectYourDevice": "Connect your device:",
  "yourProfileExistsButItsSecureDownloadLinkIs": "Your profile exists but its secure download link is not wired yet. Contact your administrator.",
  "noVPNConfigHasBeenProvisionedForYourAccount": "No VPN config has been provisioned for your account yet.",
  "routedApps": "Routed Apps",
  "manageInVPNControl": "Manage in VPN Control",
  "checkingForYourWireGuardConfig": "Checking for your WireGuard config…",
  "downloadsYourWireGuardTunnelConfigConf": "Downloads your WireGuard tunnel config (.conf)",
  "importThisFileIntoTheWireGuardClientOnYour": "Import this file into the WireGuard client on your device. After a gateway mode change, re-download — your keys are rotated.",
  "yourAdministratorHasnTGeneratedAWireGuardConfigFor": "Your administrator hasn't generated a WireGuard config for your account yet.",
  "myConnection": "My Connection",
  "checkingYourConnection": "Checking your connection…",
  "tunnelIP": "Tunnel IP:",
  "notConnectedYetBringUpTheTunnelInYour": "Not connected yet. Bring up the tunnel in your WireGuard client to see live stats.",
  "backupFailed": "Backup failed",
  "requestFailed": "Request failed",
  "failedToLoadDatabases": "Failed to load databases",
  "failedToLoadTables": "Failed to load tables",
  "failedToLoadSchema": "Failed to load schema",
  "failedToLoadRows": "Failed to load rows",
  "failedToLoadLogs": "Failed to load logs",
  "eventSourceIsNotSupportedInThisBrowser": "EventSource is not supported in this browser.",
  "unableToConnectToLogStreamAfterMultipleAttempts": "Unable to connect to log stream after multiple attempts.",
  "anErrorOccurredInTheLogStream": "An error occurred in the log stream.",
  "statsStreamDisconnected": "Stats stream disconnected",
  "failedToLoadDuplicates": "Failed to load duplicates",
  "failedToFetchActivity": "Failed to fetch activity",
  "failedToLoadSyncActivity": "Failed to load sync activity",
  "failedToReadSyncStatus": "Failed to read sync status",
  "failedToUpdateRoute": "Failed to update route",
  "failedToLoadVPNConfig": "Failed to load VPN config",
  "failedToLoadPlugins": "Failed to load plugins",
  "actionAlreadyInProgress": "Action already in progress",
  "notAuthenticated": "Not authenticated",
  "failedToFetchApps": "Failed to fetch apps",
  "failedToSearchUsers": "Failed to search users",
  "applicationControl": "Application Control",
  "control": "Control",
  "packageManagement": "Package Management",
  "packages": "Packages",
  "returningToQuickBox": "Returning to QuickBox…",
  "failedToRestartTargetUnit": "Failed to restart {{targetUnit}}",
  "targetUnitRestarted": "{{targetUnit}} restarted",
  "labelServiceUnit": "{{label}} service unit",
  "restartUnitName": "Restart {{unitName}}",
  "labelLabel2Port": "{{label}} {{label2}} port",
  "labelSocketPath": "{{label}} socket path",
  "labelAPIKey": "{{label}} API key",
  "startAppLabel": "Start {{appLabel}}",
  "stopAppLabel": "Stop {{appLabel}}",
  "restartAppLabel": "Restart {{appLabel}}",
  "launchAppLabel": "Launch {{appLabel}}",
  "navLabelSettings": "{{navLabel}} settings",
  "labelPort": "{{label}} port",
  "labelSocket": "{{label}} socket",
  "releaseChannelLabel": "Release channel: {{label}}",
  "migrationTargetLatest": "{{migrationTarget}} latest",
  "migrateToMigrationTarget": "Migrate to {{migrationTarget}}",
  "toggleLabel": "Toggle {{label}}",
  "failedToToggleLabel": "Failed to toggle {{label}}",
  "preRestoreBackupCreatedAtBackupCreated": "Pre-restore backup created at {{backupCreated}}",
  "deleteFilename": "Delete {{filename}}",
  "backupCreatedAtBackupPath": "Backup created at {{backupPath}}",
  "saveDisabledAppLabelHasNotCreatedThisFileYet": "Save disabled — {{appLabel}} has not created this file yet",
  "keyBeforeValChangedToAfterVal": "{{key}}: {{beforeVal}} changed to {{afterVal}}",
  "keyBeforeValUnchanged": "{{key}}: {{beforeVal}} unchanged",
  "databaseReconcileModeLabel": "Database reconcile · {{modeLabel}}",
  "failedToCopyLabel": "Failed to copy {{label}}",
  "labelCopied": "{{label}} copied",
  "keptKeptDeletedDeletedUpdatedUpdated": "Kept {{kept}}, deleted {{deleted}}, updated {{updated}}.",
  "countDuplicateRowsDetectedOpenReconcileActions": "{{count}} duplicate rows detected — open reconcile actions",
  "nameIsACorePluginAndCannotBeRemoved": "{{name}} is a core plugin and cannot be removed",
  "confirmRemovingNameServerWide": "Confirm removing {{name}} server-wide",
  "toggleVPNRoutingForLabel": "Toggle VPN routing for {{label}}",
  "localReverseProxyTargetForLabel": "Local reverse-proxy target for {{label}}",
  "copyDisplayNameConfigToClipboard": "Copy {{displayName}} config to clipboard",
  "downloadUsernameVPNProfileBundle": "Download {{username}} VPN profile bundle",
  "downloadUsernameWireGuardConfig": "Download {{username}} WireGuard config",
  "backupStartedForLabel": "Backup started for {{label}}",
  "hTTPStatus": "HTTP {{status}}",
  "reconcileFailedHTTPStatus": "Reconcile failed (HTTP {{status}})",
  "failedToFetchAppsStatus": "Failed to fetch apps: {{status}}",
  "failedToSearchUsersStatus": "Failed to search users ({{status}})",
  "columnsCount": "Columns: {{count}}",
  "tablesCount": "Tables: {{count}}",
  "rowsCount": "Rows: {{count}}",
  "maskedCount": "Masked: {{count}}",
  "pageSize": "{{count}} per page",
  "rowRange": "Rows {{start}}–{{end}} of {{total}}",
  "noRunningApps": "No running applications",
  "noStoppedApps": "No stopped applications",
  "noDisabledApps": "No disabled applications",
  "configBackupCount": "Config backups: {{count}}",
  "nginxBackupCount": "Nginx backups: {{count}}",
  "fullBackupCount": "Full backups: {{count}}",
  "backupRestoreTitle": "Restore backup: {{app}}",
  "editorTitle": "Edit config: {{app}}",
  "editorUnavailable": "Saving is disabled until {{app}} creates this file itself.",
  "duplicateWarning": "This permanently deletes duplicate user_software rows. The reconciler keeps one row per user and app and writes ports from the source of truth.",
  "duplicateWarningUser": "This permanently deletes duplicate user_software rows for {{username}}. The reconciler keeps one row per user and app and writes ports from the source of truth.",
  "duplicateGroupsCount": "Duplicate groups to process: {{count}}",
  "duplicateRowsCount": "Duplicate rows detected: {{count}}",
  "duplicateHelp": "Duplicate rows found in user_software. Reconcile using qb fix database.",
  "syncEventsCount": "Sync events: {{count}}",
  "logEntriesCount": "Entries: {{count}}",
  "reconnectingCount": "Reconnecting… (attempt {{count}} of 5)",
  "passwordLength": "Password must be {{min}}–{{max}} characters.",
  "pluginRemovePrompt": "Remove {{name}} for all users?",
  "showingCount": "Showing {{count}} of {{total}}",
  "appsRoutedCount": "Apps routed: {{count}}",
  "tunnelLabel": "{{backend}} tunnel",
  "reverseProxyHelp": "Point another service (for example, the Streaming Dashboard) at this address to reach {{app}} through the tunnel.",
  "routingDisabledHelp": "Routing is off. Turn it on to send {{app}} traffic through the VPN and see live metrics.",
  "enableFailed": "Failed to enable {{app}}",
  "disableFailed": "Failed to disable {{app}}",
  "appEnabled": "{{app}} enabled",
  "appDisabled": "{{app}} disabled",
  "startSucceeded": "{{app}} started",
  "stopSucceeded": "{{app}} stopped",
  "restartSucceeded": "{{app}} restarted",
  "startFailed": "Failed to start {{app}}",
  "stopFailed": "Failed to stop {{app}}",
  "restartFailed": "Failed to restart {{app}}",
  "serviceStartFailed": "Failed to start service",
  "serviceStopFailed": "Failed to stop service",
  "serviceRestartFailed": "Failed to restart service",
  "pluginInstall": "Install {{name}} server-wide",
  "pluginRemove": "Remove {{name}} server-wide",
  "pluginInstallFailed": "Failed to install plugin",
  "pluginRemoveFailed": "Failed to remove plugin",
  "vpnRoutingEnabled": "VPN routing for {{app}} is now on.",
  "vpnRoutingDisabled": "VPN routing for {{app}} is now off.",
  "noCustomPassword": "No custom password set.",
  "rollback": "Rollback",
  "confirmRollback": "Confirm Rollback",
  "confirmRestore": "Confirm Restore",
  "iPTVBossXCServer": "IPTVBoss XC Server",
  "iPTVBossRecentSync": "IPTVBoss Recent Sync",
  "theXCServerIsStoppedSyncActivityAppearsHere": "The XC Server is stopped. Sync activity appears here once it runs.",
  "switchToTheFullLogToSeeEveryLine": "Switch to the full log to see every line, or widen the range.",
  "shownInYourBrowserSTimeZoneTheApp": "Shown in your browser's time zone (the app's zone could not be determined).",
  "noPluginsAvailable": "No plugins available",
  "noPluginsMatchYourSearch": "No plugins match your search",
  "error": "Error",
  "noRecentLogEntriesThisApplicationIsCurrentlyStopped": "No recent log entries. This application is currently stopped.",
  "noLogEntriesFoundForThisTimeRange": "No log entries found for this time range.",
  "ended": "Ended",
  "paused": "Paused",
  "connected": "Connected",
  "idle": "Idle",
  "appDashboard": "App Dashboard",
  "installRemoveOrReinstallSoftwarePackages": "Install, remove, or reinstall software packages.",
  "monitorAndControlYourInstalledApplicationsAndServices": "Monitor and control your installed applications and services.",
  "logSourceFile": "Log file",
  "logSourceJournal": "Service journal",
  "logSourceEnded": "The log file ended. Active source: {{source}}.",
  "logSourceUnavailable": "The service journal is unavailable. Active source: {{source}}.",
  "logSourceReadFailed": "Could not read the system log. Active source: {{source}}.",
  "logSourceMissing": "The log file is missing. Active source: {{source}}.",
  "logSourceStartFailed": "The log reader failed to start. Active source: {{source}}.",
  "logSourceFollowing": "Active source: {{source}}.",
  "priorityEmergency": "Emergency",
  "priorityAlert": "Alert",
  "priorityCritical": "Critical",
  "priorityError": "Error",
  "priorityWarning": "Warning",
  "priorityNotice": "Notice",
  "priorityInfo": "Info",
  "priorityDebug": "Debug",
  "upload": "Upload",
  "lastWrittenAt": "Last written: {{date}}",
  "fileLastWrittenAt": "{{file}} last written: {{date}}",
  "fullBackupInitiated": "Full backup initiated",
  "configBackupInitiated": "Config backup initiated",
  "nginxBackupInitiated": "Nginx backup initiated",
  "nginxRestoredFromBackup": "Restored Nginx configuration from backup",
  "configRestoredFromBackup": "Restored configuration from backup",
  "rcConversionTitle": "rtorrent configuration notice",
  "rcConversionConverted": "The file was converted for the installed rtorrent version.",
  "rcConversionReviewNeeded": "The file was restored but still contains directives this rtorrent version does not recognize. Review it before restarting."
} as const;
